import { ChevronDown, Calendar, FileText, Sparkles, Activity } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

const markdownComponents = {
  h2: ({children}) => <h2 className="text-sm font-bold text-slate-800 mt-3 mb-1.5">{children}</h2>,
  h3: ({children}) => <h3 className="text-sm font-semibold text-slate-700 mt-2 mb-1">{children}</h3>,
  p: ({children}) => <p className="text-sm text-slate-600 mb-2 leading-relaxed">{children}</p>,
  strong: ({children}) => <strong className="font-semibold text-slate-800">{children}</strong>,
  ul: ({children}) => <ul className="list-disc list-inside space-y-0.5 mb-2 text-sm">{children}</ul>,
  li: ({children}) => <li className="text-slate-600">{children}</li>,
};

export default function LabReportCard({
  isExpanded, onToggle, latestReport, currentArea, areaSamples
}) {
  const reportDate = latestReport?.date 
    ? new Date(latestReport.date).toLocaleDateString('nb-NO', { day: 'numeric', month: 'short', year: 'numeric' })
    : null;

  return (
    <div className="bg-white rounded-xl border border-slate-100 mb-6 overflow-hidden">
      <button 
        onClick={onToggle}
        className="w-full px-5 py-4 flex items-center justify-between hover:bg-slate-50/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-violet-50 flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-violet-600" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-slate-900 text-sm">Laboratoriesammendrag</h3>
            <div className="flex items-center gap-2 mt-0.5">
              {latestReport ? (
                <>
                  <span className="inline-flex items-center gap-1 text-[10px] font-medium text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100">
                    <Activity className="w-3 h-3" />Live
                  </span>
                  <span className="text-[11px] text-slate-400 flex items-center gap-1">
                    <Calendar className="w-3 h-3" />{reportDate}
                  </span>
                  {latestReport.area_name && (
                    <span className="text-[11px] text-slate-400">{latestReport.area_name}</span>
                  )}
                </>
              ) : (
                <span className="text-[11px] text-slate-400">Ingen rapport for {currentArea?.name || 'valgt område'}</span>
              )}
            </div>
          </div>
        </div>
        
        <div className={`w-7 h-7 rounded-lg bg-slate-100 flex items-center justify-center transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}>
          <ChevronDown className="w-4 h-4 text-slate-400" />
        </div>
      </button>
      
      <div className={`transition-all duration-300 ease-out ${isExpanded ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <div className="px-5 pb-5 pt-1 border-t border-slate-100">
          {latestReport?.ai_summary ? (
            <div className="bg-slate-50 rounded-lg p-4">
              <div className="prose prose-slate prose-sm max-w-none">
                <ReactMarkdown components={markdownComponents}>
                  {latestReport.ai_summary}
                </ReactMarkdown>
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <FileText className="w-8 h-8 text-slate-300 mx-auto mb-2" />
              <p className="text-sm text-slate-500">Ingen rapport tilgjengelig for {currentArea?.name || 'dette området'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
